var errorMessageMap = new Map([
    ['maxLength', function (prop) { return "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 ".concat(prop !== null && prop !== void 0 ? prop : ''); }],
    ['negativeSum', function () { return 'Число должно быть положительным'; }],
    ['required', function () { return 'Обязательно для заполнения'; }],
    ['email', function () { return 'Некорректный email'; }],
    ['regex', function (prop) { return "\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u044F\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D\u0443".concat(prop ? ': ' + prop : ''); }],
    ['minLength', function (prop) { return "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(prop !== null && prop !== void 0 ? prop : ''); }],
    [
        'incorrectPasswordSymbols',
        function () {
            return 'Пароль должен содержать минимум 1 цифру, специальный символ, маленькую и большую буквы';
        },
    ],
    ['incorrectNumber', function () { return 'Неверный номер телефона'; }],
    ['incorrectDataFormat', function () { return 'Неверный формат даты'; }],
    ['requiredSelectElement', function () { return 'Выберите хотя-бы один элемент из списка'; }],
    ['fileWasNotChosen', function () { return 'Файл не выбран'; }],
]);
export var getErrorMessage = function (type, value) {
    if (errorMessageMap.has(type)) {
        return errorMessageMap.get(type)(value);
    }
    else {
        return 'Что-то пошло не так...';
    }
};
